import { render } from "./ScrollTop.vue?vue&type=template&id=65368fac"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"

import "./ScrollTop.vue?vue&type=style&index=0&id=65368fac&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__